import React from 'react';
import { HashRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Home from './Home';
import Booking from './components/Booking';
import Contact from './components/Contact';
import Footer from './components/Footer';

// Componente para redirecionar automaticamente baseado no idioma do navegador
const LanguageRedirect = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const browserLang = navigator.language || navigator.userLanguage; // ex: "en-US", "pt-BR"

    if (browserLang.startsWith('pt')) {
      navigate('/pt', { replace: true });
    } else {
      navigate('/en', { replace: true });
    }
  }, [navigate]);

  return null; // não renderiza nada
};

const App = () => {
  return (
    <HashRouter>
      <Routes>
        {/* Rota raiz apenas para redirecionamento automático */}
        <Route path="/" element={<LanguageRedirect />} />

        {/* Rotas para português */}
        <Route path="/pt" element={<Home lang="pt" />} />
        <Route path="/pt/booking" element={<Booking lang="pt" />} />
        <Route path="/pt/contact" element={<Contact lang="pt" />} />

        {/* Rotas para inglês */}
        <Route path="/en" element={<Home lang="en" />} />
        <Route path="/en/booking" element={<Booking lang="en" />} />
        <Route path="/en/contact" element={<Contact lang="en" />} />

        {/* Redirecionamento de qualquer rota inválida para raiz */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* Footer global */}
      <Footer />
    </HashRouter>
  );
};

export default App;
